module.exports = __webpack_public_path__ + "img/we-need-you.9faac291.png";